import { useState, useEffect, useRef } from 'react';
import apiClient from '../utils/apiClient';

export function useRecipeWithImage(recipeId, initialRecipe = null) {
  const [recipe, setRecipe] = useState(initialRecipe);
  const [loading, setLoading] = useState(true);
  const retryCountRef = useRef(0); // mutable ref to track retry count
  const intervalRef = useRef(null);

  const MAX_RETRIES = 5;

  useEffect(() => {
    const fetchRecipe = async () => {
      if (retryCountRef.current >= MAX_RETRIES) {
        console.warn(`Max retries (${MAX_RETRIES}) reached for recipeId: ${recipeId}. Stopping polling.`);
        clearInterval(intervalRef.current);
        setLoading(false);
        return;
      }

      try {
        const res = await apiClient.get(`/recipes/recipe/${recipeId}`);
        const data = res.data;
        setRecipe(data);

        if ('image' in data ? data.image : true) {
          clearInterval(intervalRef.current);
        } else {
          retryCountRef.current += 1;
        }

      } catch (err) {
        console.error('Failed to load recipe:', err);
        retryCountRef.current += 1;
      } finally {
        setLoading(false);
      }
    };

    fetchRecipe(); // immediate fetch
    intervalRef.current = setInterval(fetchRecipe, 7000);

    return () => clearInterval(intervalRef.current);
  }, [recipeId]); // only rerun if recipeId changes

  return { recipe, loading: recipe === null };
}
